import {Component, OnInit, ElementRef, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {NbDateService} from '@nebular/theme';
@Component({
  selector: 'ngx-date-time-range-picker',
  templateUrl: './date-time-range-picker.component.html',
  styleUrls: ['./date-time-range-picker.component.scss'],
})
export class DateTimeRangePickerComponent implements OnInit {

  @Output() rangeEmitter: EventEmitter<any> = new EventEmitter();
  @Output() customRange: EventEmitter<boolean> = new EventEmitter();
  @Input()
  todayAllowed = true;
  selectedCustomRange: Date[];
  defaultDate: Date;
  selectedDate = 'Pick Date';
  range = {
    start : moment().startOf('day').format('YYYY-MM-DDTHH:mm'),
    end : moment().format('YYYY-MM-DDTHH:mm'),
  };
  maxDate = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm');

  // @ViewChild('InputElement', {static : true}) myDiv: ElementRef<HTMLElement>;
  constructor(protected dateService: NbDateService<Date>) {
    this.defaultDate = this.dateService.today();
    this.defaultDate.setHours(0, 0 , 0);
  }

  ngOnInit(): void {
    if (this.todayAllowed) {
      this.maxDate = moment().format('YYYY-MM-DDTHH:mm');
    }
    this.fillDateLabel();
  }


  emitToday(): void {
    this.range = {
      start : moment().startOf('day').format('YYYY-MM-DDTHH:mm'),
      end : moment().format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitYesterday(): void {
    this.range = {
      start : moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
      end : moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitLast7Days(): void {
    this.range = {
      start : moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DDTHH:mm'),
      end : moment().format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitLast30Days(): void {
    this.range = {
      start : moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DDTHH:mm'),
      end : moment().format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitThisMonth(): void {
    this.range = {
      start : moment().startOf('month').format('YYYY-MM-DDTHH:mm'),
      end : moment().format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitLastMonth(): void {
    this.range = {
      start : moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DDTHH:mm'),
      end : moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DDTHH:mm'),
    };
    this.rangeEmitter.emit(this.range);
    this.fillDateLabel();
  }

  emitCustomRange(): void {
    this.customRange.emit(true);
  }


  fillDateLabel(): void {
    this.selectedDate = moment(this.range.start).format('DD-MM-YYYY HH:mm');
    this.selectedDate += ' - ' + moment(this.range.end).format('DD-MM-YYYY HH:mm');
    // const el: HTMLElement = this.myDiv.nativeElement;
    // el.click();
  }

}
